var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6_svg__a)",
    fill: "#EF3124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 40.582H8V47h31v-6.418ZM29.178 4.693C28.301 2.073 27.271 0 23.785 0c-3.486 0-4.582 2.074-5.503 4.693L8.68 31.85h6.357l2.215-6.462h12.233l2.061 6.462h6.774L29.178 4.693Zm-10.063 15.26 4.341-12.88h.154l4.1 12.88h-8.595Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h47v47H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.347b98e551ef77f43bcb0d02aa4680cb.svg";
export { ForwardRef as ReactComponent };